import Dropdown from "./Dropdown";
import ChannelImageRow from "./ChannelImageRow";
import O from "./O";
import Id from './IdFactory';





export default function ImageInsertionChannelMatching({
  template,
  accept,
  channels,//s=defaultChannels,
  onEvent,
  focusedImageId,
  templateEvals,
  setTemplateEvals,
}){



  return (
    <div class="sg-col full-width rel" style={{
    }}>
      
      

      <div class="sg-row h-center small-margin-top v-center ">

        <div class="flex-expand"/>

        <h4 class="">Assign Channels</h4>

        <div style={{textAlign:'center'}} class="flex-expand">

          <div>
        

            <div onClick={() => {
              return;
              let newId = Id();
              let defaultValue = Math.max(
                ...Object.values(channels).map(x => x.defaultValue),
              )+1;

              let newChannel={
                color:"none",
                defaultValue,
                label:"",
              }
              onEvent({
                type:"templateChange",
                properties:{
                  [`compact.channels.${newId}`]:newChannel,
                  [`channels.${newId}`]:newChannel
                }
              })

            }} class="small-padding round-corners hoverable" style={{fontSize:24, lineHeight:0.7}}>
                +
              </div>

        </div>
        </div>

               

      </div>
      


      <table style={{borderTop:'1px solid #ccc',}}>



    {Object.entries(template.compact.channels).map((entry,ii) => {
      let [channelId,channel] = entry;;
      let evalItem = templateEvals[ii];
      if( evalItem.hidden ){
        return null;
      }
      let {nodeId,imageId,imageSetId} = evalItem;
      return (<ChannelImageRow key={nodeId} {...{
        setTemplateEvals,
        templateEvals,
        channel,
        channels:template.channels,
        imageId,
        focusedImageId,
        accept,
        channelId:nodeId,
        channelIndex:ii,
        onEvent,
      }}/>)
    })}
      </table>


    </div>
  )

}
